import { Node as ProseNode } from 'prosemirror-model'

export const isEmptyNode = (node: ProseNode) => {
  const c = node.content

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return c.childCount === 1 && c.firstChild!.isTextblock && c.firstChild!.childCount === 0
}
